import React, { createContext, useContext, useState, useEffect } from "react";
import { useCurrentUser } from "./UserContext"; // Assuming this provides authentication status
import axios from "axios";
import apiClient from "@/api/apiClient";
import { getLeaveTypes } from "@/api/leave-types";
import { LeaveType } from "@/models/leave-types.model";

// Create LeaveTypesContext
const LeaveTypesContext = createContext<any>(null);

// Provide context to children components
export const LeaveTypesProvider = ({ children }: { children: React.ReactNode }) => {
    const { currentUser } = useCurrentUser(); // Get current user from context
    const [leaveTypes, setLeaveTypes] = useState<LeaveType[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    // Fetch leave types only if the user is authenticated
    useEffect(() => {
        if (currentUser) {
            // User is authenticated, fetch leave types
            const fetchLeaveTypes = async () => {
                try {
                    setLoading(true);
                    const data = await getLeaveTypes()
                    setLeaveTypes(data);
                } catch (err) {
                    setError("Failed to fetch leave types");
                } finally {
                    setLoading(false);
                }
            };
            fetchLeaveTypes();
        } else {
            setLoading(false);
        }
    }, [currentUser]); // Re-run when currentUser changes

    return (
        <LeaveTypesContext.Provider value={{ leaveTypes, loading, error }}>
            {children}
        </LeaveTypesContext.Provider>
    );
};

// Custom hook to access leave types context
export const useLeaveTypes = () => {
    return useContext(LeaveTypesContext);
};
